import type { MarginBasisOption } from './types';

const DEFAULT_LOCALE = 'de-DE';

/** `101.467,70 €` — the euro total, always two fraction digits. */
export function formatEuro(value: number, locale: string = DEFAULT_LOCALE): string {
  return `${value.toLocaleString(locale, { minimumFractionDigits: 2, maximumFractionDigits: 2 })} €`;
}

/**
 * A euro total expressed in the selected basis: the total itself for a
 * `divisor` of 1 (unit empty), otherwise `value ÷ divisor` with the option's
 * unit. `null` where the value or the divisor is unknown — never a fabricated
 * `0,00 €/X` (the same null-honesty the app's basis switcher keeps).
 */
export function formatInBasis(
  value: number | null,
  option: MarginBasisOption | undefined,
  locale: string = DEFAULT_LOCALE,
): string | null {
  if (value === null || value === undefined || !option || option.divisor === null || option.divisor === 0) {
    return null;
  }
  if (option.divisor === 1 && !option.unit) return formatEuro(value, locale);
  const decimals = option.decimals ?? 2;
  const scaled = value / option.divisor;
  return `${scaled.toLocaleString(locale, { minimumFractionDigits: decimals, maximumFractionDigits: decimals })} ${option.unit}`.trim();
}
